import memoizeOne from "memoize-one";
import { TableColumn } from "react-data-table-component";
import { formatToEst } from "src/common/helper";
import { Feedback } from "src/sdk/models/Ticket";

export const FeedbackSuperAdminColumns = memoizeOne(
    (

    ): TableColumn<Feedback>[] => {
        return [
            {
                name: "#",
                cell: (row, index) => index + 1,
                width: "60px",
            },
            {
                name: "Feedback",
                selector: row => row.feedback,
                wrap: true,
                grow: 2,
            },
            {
                name: "Created By",
                selector: row => row.createdBy ?? "-",
                width: "150px",
            },
            {
                name: "Created At",
                selector: row => formatToEst(row.createdAt),
                width: "200px",
            },
        ];
    }
);
